import React, { Component } from 'react';

import './App.css';

import Routes from './routes';

class App extends Component {
  componentDidMount() {
    document.title = 'Orchestrator Admin';
  }

  render() {
    return (
      <div className="App">
        <Routes />
      </div>
    );
  }
}

export default App;
